export const CHECKOUT_PATH = '/checkout';
export const QUICK_CHECKOUT_PATH = '/quick-checkout';
export const RECEIPT_PATH = '/receipt';
export const HISTORICAL_RECEIPT_PATH = '/historical-receipt';
